module.exports = __webpack_public_path__ + "img/login1.a553b47b.png";